import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { TierOvrdDialog } from '@/md/entities/tierRes/TierOvrdDialog';
import { useCallback, useState } from 'react';

export const TierResList = ({ progId }) => {
  
  const { openDialog } = useDialog();

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('progId', progId));
  }, [progId]);

  const [selectedEntities, setSelectedEntities] = useState([]);

  const handleSelectionChanged = (event) => {
    const selectedNodeData = event.api.getSelectedNodes().map(node => node.data);
    setSelectedEntities(selectedNodeData);
  };

  const openTierOvrdDialog = () => {
    if (selectedEntities.length === 0) return;
    openDialog(TierOvrdDialog, { selectedEntities: selectedEntities });
  };

  const augTabButtons = (buttons) => {
    ObjUtils.clearObj(buttons);
    buttons.push(
      <TitleButton
        key="tier-ovrd-button"
        dataTestId="tier-ovrd-button"
        icon={fas.faPencil}
        toolTip="Override Tier"
        onClick={openTierOvrdDialog}
      />
    );
  };

  return (
    <EntityList
      entity="TIER_RES"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      gridOptions={{ rowSelection: 'multiple' }}
      events={{ onSelectionChanged: handleSelectionChanged }}
    />
  );
};
